import { render, staticRenderFns } from "./ErrorAlert.vue?vue&type=template&id=e450cf80"
import script from "./ErrorAlert.vue?vue&type=script&lang=ts"
export * from "./ErrorAlert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports